import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ImpersonationService } from '@features/impersonation/services/impersonation.service';
import { UserService } from '@features/user/services/user.service';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/** Admits only once the server accepts impersonating the client in the URL. */
export const startImpersonationGuard: CanActivateFn = route => {
    const router = inject(Router);
    const clientId = route.paramMap.get('clientId');
    const backToClient = router.createUrlTree(['/office/clients', clientId]);
    inject(ImpersonationService).start(clientId);
    return inject(UserService)
        .fetch_user()
        .pipe(
            map(user => !!user.impersonated_by || backToClient),
            catchError(() => of(backToClient))
        );
};
